import React from "react";
import { Route, Switch } from "react-router-dom";

import Login from "./modules/Login";
import RecoverPassword from "./modules/RecoverPassword";
import ChangePassword from "./modules/ChangePassword";
import Dashboard from "./modules/Dashboard";
import Signings from "./modules/Signings";
import Users from "./modules/Users";
import Clients from "./modules/Clients";
import EditUser from "./modules/EditUser";
import EditClient from "./modules/EditClient";
import EditSigning from "./modules/EditSigning";
import Schedule from "./modules/Schedule";
import ArticleTypes from "./modules/ArticleTypes";
import Articles from "./modules/Articles";
import EditArticle from "./modules/EditArticle";
import EditArticleType from "./modules/EditArticleType";
import EditTax from "./modules/EditTax";
import Taxes from "./modules/Taxes";
import Operations from "./modules/Operations";
import EditOperation from "./modules/EditOperation";
import Bills from "./modules/Bills";
import EditBill from "./modules/EditBill";
import Locations from "./modules/Locations";
import EditLocation from "./modules/EditLocation";
import Reports from "./modules/Reports";
import Bookings from "./modules/Bookings";

const Routes = () =>
  <Switch>
    <Route path="/" exact component={Dashboard} />
    <Route path="/login" exact component={Login} />
    <Route path="/recover_password" exact component={RecoverPassword} />
    <Route path="/change_password" exact component={ChangePassword} />
    <Route path="/dashboard" exact component={Dashboard} />
    <Route path="/signings" exact component={Signings} />
    <Route path="/users" exact component={Users} />
    <Route path="/edit_user" exact component={EditUser} />
    <Route path="/edit_signing" exact component={EditSigning} />
    <Route path="/schedule" exact component={Schedule} />
    <Route path="/clients" exact component={Clients} />
    <Route path="/edit_client" exact component={EditClient} />
    <Route path="/article_types" exact component={ArticleTypes} />
    <Route path="/edit_article_type" exact component={EditArticleType} />
    <Route path="/articles" exact component={Articles} />
    <Route path="/edit_article" exact component={EditArticle} />
    <Route path="/taxes" exact component={Taxes} />
    <Route path="/edit_tax" exact component={EditTax} />
    <Route path="/operations" exact component={Operations} />
    <Route path="/edit_operation" exact component={EditOperation} />
    <Route path="/bills" exact component={Bills} />
    <Route path="/edit_bill" exact component={EditBill} />
    <Route path="/locations" exact component={Locations} />
    <Route path="/edit_location" exact component={EditLocation} />
    <Route path="/reports" exact component={Reports} />
    <Route path="/bookings" exact component={Bookings} />
  </Switch>;

  export default Routes;
